<template>
  <div id="pageContainer" :class="cssClass">
    <LazyIdleLibHeroCanvas hydrate-on-idle />
    <LibErrorBoundary component-name="LibPageHeader">
      <LazyIdleLibPageHeader hydrate-on-idle />
    </LibErrorBoundary>
    <LibErrorBoundary component-name="Page Content Slot">
      <main id="top" class="page-content">
        <slot />
      </main>
    </LibErrorBoundary>
    <LibErrorBoundary component-name="LibPageFooter">
      <LazyVisibleLibPageFooter hydrate-on-visible />
    </LibErrorBoundary>
    <ProductDetailActionBar v-if="isPdp" />
  </div>
</template>

<script setup lang="ts">
import ProductDetailActionBar from '~/components/shop/ProductDetailActionBar.vue';
import { isProductDetailPage } from '~/utils/shop/isProductDetailPage';

const colorMode = useInjectedColorMode();
const route = useRoute();

const isPdp = ref(isProductDetailPage(route.path));

// Watcher für Seitenwechsel - prüft bei jeder Route-Änderung ob wir auf PDP sind
watch(
  () => route.path,
  (newPath) => {
    isPdp.value = isProductDetailPage(newPath);
  },
  { immediate: true }
);

watch(
  () => colorMode.value,
  () => {
    // QUICKFIX because computed cssClass will not change in DOM ?!
    if (import.meta.client && colorMode.value) {
      const classList = document.getElementById('pageContainer')?.classList;
      if (classList) {
        ['dark', 'light', 'dark-purple'].forEach((color) => {
          classList.remove(`page-wrapper--${color}`);
        });
        classList.add(`page-wrapper--${colorMode.value}`);
      }
    }
  },
  { immediate: true }
);

const cssClass = computed(() => {
  return {
    'page-wrapper': true,
    'page-wrapper--dark': colorMode.value === 'dark',
    'page-wrapper--dark-purple': colorMode.value === 'dark-purple',
    'page-wrapper--light': colorMode.value === 'light'
  };
});
</script>

<style scoped>
.audiences-widget {
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>
